var GEO_DATA, Location, breakDownAddress, findSearchOverridesLink, getFormattedQueryString, getGeoSearchOverrideUrl, getLocationForSearch, getLocationOverrideUrl, getSearchOverrideUrl, getSearchUrl, normalizeQuery, storeGeolocationData,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

Location = require('./m_location_helper');

normalizeQuery = require('./m_normalizeQuery');


/*
 * @type {Array} GEO_DATA Location attributes to exclude
 */

GEO_DATA = ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code'];


/*
 * Splits address into address components (e.g "Chicago, IL" into "Chicago" and "IL")
 *
 * @param   {Object} data {address}               - Location object
 * @returns {Object} data {address, geoCoderData} - Split address data
 */

breakDownAddress = function(data) {
  var address, currentLocation, geocoderData, ref;
  currentLocation = data.currentLocation;
  address = ((data != null ? (ref = data.address) != null ? ref.split(',') : void 0 : void 0) || []).map(function(s) {
    return s.trim();
  });
  data = _.omit(data, GEO_DATA);
  if (!currentLocation) {
    geocoderData = {
      friendlyName: data.address,
      fullAddress: data.address
    };
    switch (address.length) {
      case 1:
        geocoderData.postal_code = address[0];
        break;
      case 2:
        geocoderData.locality = address[0], geocoderData.administrative_area = address[1];
        break;
      case 3:
        geocoderData.neighborhood = address[0], geocoderData.locality = address[1], geocoderData.administrative_area = address[2];
    }
  }
  data.geocoderData = geocoderData || {};
  return data;
};


/*
 * Returns link if query matches deal override config
 *
 * @param   {String}      query          - User query
 * @param   {Boolean}     [isMobile2016] - Flag indicating mobile2016 (optional)
 * @returns {Null|String} link           - Link for matching query
 */

findSearchOverridesLink = function(query, isMobile2016) {
  var i, len, link, ref, ref1, searchOverrides, terms;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  searchOverrides = ((ref = window.Groupon.LS.data) != null ? ref.searchOverrides : void 0) || [];
  if ((searchOverrides != null ? searchOverrides.length : void 0) && query) {
    searchOverrides = searchOverrides.filter(function(item) {
      return !item.hasOwnProperty('locations');
    });
    query = query.toLowerCase().trim();
    if (isMobile2016) {
      searchOverrides = searchOverrides.filter(function(item) {
        return item.m2016;
      });
    }
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms;
      if (indexOf.call(terms, query) < 0) {
        continue;
      }
      return link;
    }
  }
  return null;
};


/*
 * Get division object if existent
 *
 * @returns {Object} {lat, lng, fullAddress, closestDivision} Returns division object
 */

getLocationForSearch = function() {
  var division;
  if (division = Location.getDivision()) {
    return {
      lat: division.lat,
      lng: division.lng,
      fullAddress: Location.userFriendlyLocation(division),
      closestDivision: division.id
    };
  }
};


/*
 * Parametrizes and picks unique url arguments
 *
 * @param   {Object} params - Url parameter
 * @returns {String}        - Parametrized url arguments
 */

getFormattedQueryString = function(params) {
  if (params == null) {
    params = {};
  }
  params.locale = document.head.getAttribute('data-locale');
  return $.param(_.pick(params, _.identity)).replace(/\s|%20/g, '+');
};


/*
 * Build PULL url from arguments to complete search submit
 *
 * @param   {String} divisionId - Unique division name
 * @param   {Object} params     - Url parameter
 * @returns {String}
 */

getSearchUrl = function(divisionId, params) {
  var urlParams;
  urlParams = getFormattedQueryString(params);
  return "/browse/" + divisionId + "?" + urlParams;
};


/*
 * LS-750 and LS-765
 * Returns link if query matches location override config
 *
 * @param   {String}      query   - User query
 * @param   {String}      address - Address
 * @returns {Null|String} link    - Link for matching query
 */

getGeoSearchOverrideUrl = function(query, address) {
  var i, j, k, len, len1, len2, link, loc, locations, ref, ref1, searchOverrides, term, terms;
  searchOverrides = ((ref = Groupon.LS.data) != null ? ref.searchOverrides : void 0) || {};
  if (searchOverrides != null) {
    address = normalizeQuery(address != null ? address.toLowerCase().trim() : void 0);
    query = normalizeQuery(query != null ? query.toLowerCase().trim() : void 0);
    for (i = 0, len = searchOverrides.length; i < len; i++) {
      ref1 = searchOverrides[i], link = ref1.link, terms = ref1.terms, locations = ref1.locations;
      if ((locations != null) && (terms != null)) {
        locations = _.map(locations, normalizeQuery);
        terms = _.map(terms, normalizeQuery);
        if (indexOf.call(locations, address) >= 0 && indexOf.call(terms, query) >= 0) {
          return link;
        }
        for (j = 0, len1 = locations.length; j < len1; j++) {
          loc = locations[j];
          for (k = 0, len2 = terms.length; k < len2; k++) {
            term = terms[k];
            if (query === (term + '-' + loc) || query === (loc + '-' + term)) {
              return link;
            }
          }
        }
      }
    }
  }
  return null;
};


/*
 * Returns link if query matches override config
 *
 * @param   {String}                            divisionId - Unique division name
 * @param   {Object} {address, lat, lng, query} attributes
 * @returns {Null|String}                       url        - Link for matching query
 */

getSearchOverrideUrl = function(divisionId, attributes, isMobile2016) {
  var address, key, lat, lng, query, ref, url, val;
  if (isMobile2016 == null) {
    isMobile2016 = false;
  }
  address = attributes.address, lat = attributes.lat, lng = attributes.lng, query = attributes.query;
  url = findSearchOverridesLink(query, isMobile2016);
  if (url == null) {
    return;
  }
  if (url === '/travel') {
    url += '?lat={lat}&lng={lng}&query={query}&address={address}';
  }
  ref = {
    address: address,
    lat: lat,
    lng: lng,
    query: query,
    division: divisionId
  };
  for (key in ref) {
    val = ref[key];
    url = url.replace('{' + key + '}', val);
  }
  return url.replace(/\s/g, '+');
};


/*
 * Returns link if query matches location override config
 *
 * @param   {Object}      {address} - Attributes
 * @returns {Null|String}           - Link for matching query
 */

getLocationOverrideUrl = function(attributes) {
  var address, i, len, link, locations, overrides, query, ref, ref1;
  address = attributes.address;
  overrides = ((ref = Groupon.LS.data) != null ? ref.locationOverrides : void 0) || {};
  if (overrides != null) {
    for (i = 0, len = overrides.length; i < len; i++) {
      ref1 = overrides[i], link = ref1.link, locations = ref1.locations;
      if (indexOf.call(locations, address) < 0) {
        continue;
      }
      query = getFormattedQueryString(attributes);
      return link + "?" + query;
    }
  }
  return null;
};


/*
 * LS-2211 geolocation
 * Writes location data to browser's localStorage
 *
 * @param   {Boolean}     setCurrentLocation
 * @param   {Object}      data               - Location data
 * @returns {Null|String}                    - Link for matching query
 */

storeGeolocationData = function(setCurrentLocation, data) {
  if (setCurrentLocation) {
    return Location.setGeolocationData('current_location', data);
  } else {
    return Location.removeGeolocationData('current_location');
  }
};

module.exports = {
  breakDownAddress: breakDownAddress,
  findSearchOverridesLink: findSearchOverridesLink,
  getFormattedQueryString: getFormattedQueryString,
  getGeoSearchOverrideUrl: getGeoSearchOverrideUrl,
  getLocationForSearch: getLocationForSearch,
  getLocationOverrideUrl: getLocationOverrideUrl,
  getSearchOverrideUrl: getSearchOverrideUrl,
  getSearchUrl: getSearchUrl,
  GEO_DATA: GEO_DATA,
  storeGeolocationData: storeGeolocationData
};

//# sourceMappingURL=data:application/json;base64,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
